var GEO_DATA, Location, breakDownAddress, findSearchOverridesLink, getFormattedQueryString, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, normalizeQuery, storeGeolocationData,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Location = require('./m_location_helper');

normalizeQuery = require('./m_normalizeQuery');


/*
 * @type {Array} GEO_DATA Location attributes to exclude
 */

GEO_DATA = ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code'];


/*
 * Splits address into address components (e.g "Chicago, IL" into "Chicago" and "IL")
 *
 * @param   {Object} data {address}               - Location object
 * @returns {Object} data {address, geoCoderData} - Split address data
 */

breakDownAddress = function(data) {
  var address, currentLocation, geocoderData, ref;
  currentLocation = data.currentLocation;
  address = ((data != null ? (ref = data.address) != null ? ref.split(',') : void 0 : void 0) || []).map(function(s) {
    return s.trim();
  });
  data = _.omit(data, GEO_DATA);
  if (!currentLocation) {
    geocoderData = {
      friendlyName: data.address,
      fullAddress: data.address
    };
    switch (address.length) {
      case 1:
        geocoderData.postal_code = address[0];
        break;
      case 2:
        geocoderData.locality = address[0], geocoderData.administrative_area = address[1];
        break;
      case 3:
        geocoderData.neighborhood = address[0], geocoderData.locality = address[1], geocoderData.administrative_area = address[2];
    }
  }
  data.geocoderData = geocoderData || {};
  return data;
};


/*
 * Returns link if query matches deal override config
 *
 * @param   {String}      query          - User query
 * @param   {Boolean}     [isMobile2016] - Flag indicating mobile2016 (optional)
 * @returns {Null|String} link           - Link for matching query
 */

findSearchOverridesLink = function(query, isMobile2016) {
  var i, len, link, ref, ref1, searchOverrides, terms;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  searchOverrides = ((ref = window.Groupon.LS.data) != null ? ref.searchOverrides : void 0) || [];
  if ((searchOverrides != null ? searchOverrides.length : void 0) && query) {
    searchOverrides = searchOverrides.filter(function(item) {
      return !item.hasOwnProperty('locations');
    });
    query = query.toLowerCase().trim();
    if (isMobile2016) {
      searchOverrides = searchOverrides.filter(function(item) {
        return item.m2016;
      });
    }
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms;
      if (indexOf.call(terms, query) < 0) {
        continue;
      }
      return link;
    }
  }
  return null;
};


/*
 * Get division object if existent
 *
 * @returns {Object} {lat, lng, fullAddress, closestDivision} Returns division object
 */

getLocationForSearch = function() {
  var division;
  if (division = Location.getDivision()) {
    return {
      lat: division.lat,
      lng: division.lng,
      fullAddress: Location.userFriendlyLocation(division),
      closestDivision: division.id
    };
  }
};


/*
 * Parametrizes and picks unique url arguments
 *
 * @param   {Object} params - Url parameter
 * @returns {String}        - Parametrized url arguments
 */

getFormattedQueryString = function(params) {
  if (params == null) {
    params = {};
  }
  params.locale = document.head.getAttribute('data-locale');
  return $.param(_.pick(params, _.identity)).replace(/\s|%20/g, '+');
};


/*
 * Build PULL url from arguments to complete search submit
 *
 * @param   {String} divisionId - Unique division name
 * @param   {Object} params     - Url parameter
 * @returns {String}
 */

getSearchUrl = function(divisionId, params) {
  var urlParams;
  urlParams = getFormattedQueryString(params);
  return "/browse/" + divisionId + "?" + urlParams;
};


/*
 * LS-750 and LS-765
 * Returns link if query matches location override config
 *
 * @param   {String}      query   - User query
 * @param   {String}      address - Address
 * @returns {Null|String} link    - Link for matching query
 */

getGeoSearchOverrideUrl = function(query, address) {
  var i, j, k, len, len1, len2, link, loc, locations, ref, ref1, searchOverrides, term, terms;
  searchOverrides = ((ref = Groupon.LS.data) != null ? ref.searchOverrides : void 0) || {};
  if (searchOverrides != null) {
    address = normalizeQuery(address != null ? address.toLowerCase().trim() : void 0);
    query = normalizeQuery(query != null ? query.toLowerCase().trim() : void 0);
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms, locations = ref1.locations;
      if ((locations != null) && (terms != null)) {
        locations = _.map(locations, normalizeQuery);
        terms = _.map(terms, normalizeQuery);
        if (indexOf.call(locations, address) >= 0 && indexOf.call(terms, query) >= 0) {
          return link;
        }
        for (j = 0, len1 = locations.length; j < len1; j++) {
          loc = locations[j];
          for (k = 0, len2 = terms.length; k < len2; k++) {
            term = terms[k];
            if (query === (term + '-' + loc) || query === (loc + '-' + term)) {
              return link;
            }
          }
        }
      }
    }
  }
  return null;
};


/*
 * Returns link if query matches override config
 *
 * @param   {String}                            divisionId - Unique division name
 * @param   {Object} {address, lat, lng, query} attributes
 * @returns {Null|String}                       url        - Link for matching query
 */

getSearchOverrideUrl = function(divisionId, attributes, isMobile2016) {
  var address, key, lat, lng, query, ref, url, val;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  address = attributes.address, lat = attributes.lat, lng = attributes.lng, query = attributes.query;
  url = findSearchOverridesLink(query, isMobile2016);
  if (url == null) {
    return;
  }
  if (url === '/travel') {
    url += '?lat={lat}&lng={lng}&query={query}&address={address}';
  }
  ref = {
    address: address,
    lat: lat,
    lng: lng,
    query: query,
    division: divisionId
  };
  for (key in ref) {
    val = ref[key];
    url = url.replace('{' + key + '}', val);
  }
  return url.replace(/\s/g, '+');
};


/*
 * Returns link if query matches location override config
 *
 * @param   {Object}      {address} - Attributes
 * @returns {Null|String}           - Link for matching query
 */

getLocationOverrideUrl = function(attributes) {
  var address, i, len, link, locations, overrides, query, ref, ref1;
  address = attributes.address;
  overrides = ((ref = Groupon.LS.data) != null ? ref.locationOverrides : void 0) || {};
  if (overrides != null) {
    for (i = 0, len = overrides.length; i < len; i++) {
      ref1 = overrides[i], link = ref1.link, locations = ref1.locations;
      if (indexOf.call(locations, address) < 0) {
        continue;
      }
      query = getFormattedQueryString(attributes);
      return link + "?" + query;
    }
  }
  return null;
};


/*
 * LS-2211 geolocation
 * Writes location data to browser's localStorage
 *
 * @param   {Boolean}     setCurrentLocation
 * @param   {Object}      data               - Location data
 * @returns {Null|String}                    - Link for matching query
 */

storeGeolocationData = function(setCurrentLocation, data) {
  if (setCurrentLocation) {
    return Location.setGeolocationData('current_location', data);
  } else {
    return Location.removeGeolocationData('current_location');
  }
};

module.exports = {
  breakDownAddress: breakDownAddress,
  findSearchOverridesLink: findSearchOverridesLink,
  getFormattedQueryString: getFormattedQueryString,
  getGeoSearchOverrideUrl: getGeoSearchOverrideUrl,
  getLocationForSearch: getLocationForSearch,
  getLocationOverrideUrl: getLocationOverrideUrl,
  getSearchOverrideUrl: getSearchOverrideUrl,
  getSearchUrl: getSearchUrl,
  GEO_DATA: GEO_DATA,
  storeGeolocationData: storeGeolocationData
};

//# sourceMappingURL=data:application/json;base64,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
